import img1 from "../assets/aigle.png";
import img2 from "../assets/chezGaelle.jpg";
import img3 from "../assets/minister.jpg";
import img4 from "../assets/safa.jpg";


const PatnerComponent = () => {
    return (
        <>
            <div className="py-10">
                <div className="text-center py-16">
                    <h1 className="font-bold text-2xl">
                        <span className="text-[#1b1b1b] my-4">OUR </span>
                        <span className="text-[#fb923c]">PARTENER</span>
                    </h1>
                    <p className="text-center lg:w-[60%] md:w-[80%] sm:w-[100%] m-auto py-4">
                        Notre ONG accueille toutes les âmes bienveillantes. Ensemble, nous œuvrons pour un monde meilleur, où l'aide et la solidarité transcendent les frontières et les différences. Rejoignez-nous pour faire la différence, un geste à la fois.
                     </p>
                </div>
                <div className="flex justify-center flex-wrap gap-3 align-middle items-center">
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center  p-2 w-32 shadow-md border-gray-300">
                        <p>
                            <img src={img3} alt="im1" width={60} height={60} />
                        </p>
                    </div>
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center  p-2 w-32 shadow-md border-gray-300">
                        <img src={img2} alt="im1" width={60} height={60} />
                    </div>
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center shadow-md border-gray-300 p-2 w-32">
                        <img src={img1} alt="im1" width={60} height={60} />
                    </div>
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center shadow-md border-gray-300 p-2 w-32">
                        <img src={img4} alt="im1" width={60} height={60} />
                    </div>
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center shadow-md border-gray-300 p-2 w-32">
                        <img src={img1} alt="im1" width={60} height={60} />
                    </div>
                    <div className="animate__animated  animate__fadeInLeft animate__delay-1s flex justify-center shadow-md border-gray-300 p-2 w-32">
                        <img src={img4} alt="im1" width={60} height={50} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default PatnerComponent